import { IDiagnosticOrder } from '@ispm/test/interfaces/diagnostic-order.interface';
import { createSelector } from '@ngrx/store';
import { ObjectUtils } from '@ispm/shared/utils/Object.utils';
import { selectCurrentConfigPropertyValue } from '../../../../app/configuration/store/configuration.selector';
import { curationKeysPropertyName } from '../../models';
import { selectCurrentDiagnosticOrder } from '@ispm/test/store/diagnostic-order.selector';

const getCurationClinicalKeys =
  (diagnosticOrder: IDiagnosticOrder, curationClinicalKeysConfiguration: any): any =>
    (!!diagnosticOrder && !!curationClinicalKeysConfiguration) ?
      curationClinicalKeysConfiguration.map(conf => ({ key: ObjectUtils.walk(diagnosticOrder, conf.source), target: conf.target})) : null;

export const selectCurationClinicalKeys = createSelector(
  [
    selectCurrentDiagnosticOrder,
    selectCurrentConfigPropertyValue('Test',curationKeysPropertyName)
  ],
  getCurationClinicalKeys
);
